import { Pill } from '../../../components/pill/Pill';
import { useTranslation } from '../../../contexts/translation-context';
import { OrderStatus } from 'src/types/enums';
import { ORDER_STATUS_COLOR } from '../constants';

export interface IOrderStatusTagProps {
  status: OrderStatus;
}

export const OrderStatusTag: React.FC<IOrderStatusTagProps> = (props) => {
  const { status } = props;
  const { i18n } = useTranslation();

  const orderStatusName = i18n(`orderStatus.${status}`);
  return (
    <Pill color={ORDER_STATUS_COLOR[status]} size="sm">
      {orderStatusName}
    </Pill>
  );
};
